export default "/images/scout-app.png";